module.exports = __webpack_public_path__ + "static/media/titelbild1000.36c0d250.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/standalone/titelbild1000.jpg
// module id = 97
// module chunks = 0